export const isMyHotels = (parentSiteId) => [136, 137, 138, 149, 150, 1338].indexOf(parentSiteId) !== -1;

export const getConceptName = (parentSiteId) => {
  const names = {
    136: 'sunwing',
    137: 'sunprime',
    138: 'obc',
    149: 'sunclass',
    150: 'familygarden',
    1338: 'sunclass',
  };

  return names[parseInt(parentSiteId, 10)] || null;
};